/**
 * @generated SignedSource<<20f36d97b1cf006a7e7cece6f04a1555>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ActiveRecords = "ACTIVE" | "BOTH" | "INACTIVE" | "%future added value";
export type ClassesFilterInput = {
  haveAtLeastOneStudent?: boolean | null | undefined;
  isActive: ActiveRecords;
  siteIds?: ReadonlyArray<string> | null | undefined;
  siteIsActive: ActiveRecords;
};
export type ClassesGetAllQuery$variables = {
  cursor?: string | null | undefined;
  filter?: ClassesFilterInput | null | undefined;
  skip?: boolean | null | undefined;
};
export type ClassesGetAllQuery$data = {
  readonly classes?: {
    readonly nodes: ReadonlyArray<{
      readonly externalSync: {
        readonly source: string | null | undefined;
      } | null | undefined;
      readonly gradeLevels: ReadonlyArray<{
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly id: string;
      readonly isActive: boolean;
      readonly name: string | null | undefined;
      readonly owner: {
        readonly firstName: string | null | undefined;
        readonly id: string;
        readonly lastName: string | null | undefined;
      } | null | undefined;
      readonly section: string | null | undefined;
      readonly site: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
      readonly users: ReadonlyArray<{
        readonly classes: ReadonlyArray<{
          readonly name: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly firstName: string | null | undefined;
        readonly gradeLevels: ReadonlyArray<{
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly id: string;
        readonly isActive: boolean;
        readonly lastName: string | null | undefined;
        readonly publicUserId: string | null | undefined;
        readonly roles: ReadonlyArray<{
          readonly name: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly sites: ReadonlyArray<{
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined> | null | undefined;
    }> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
    };
  } | null | undefined;
};
export type ClassesGetAllQuery = {
  response: ClassesGetAllQuery$data;
  variables: ClassesGetAllQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "skip"
},
v3 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "classesFilterInput",
    "variableName": "filter"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "section",
  "storageKey": null
},
v7 = [
  (v4/*: any*/),
  (v5/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "SiteNode",
  "kind": "LinkedField",
  "name": "site",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v9 = [
  (v5/*: any*/),
  (v4/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "GradeLevelNode",
  "kind": "LinkedField",
  "name": "gradeLevels",
  "plural": true,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publicUserId",
  "storageKey": null
},
v15 = [
  (v5/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "SiteNode",
  "kind": "LinkedField",
  "name": "sites",
  "plural": true,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "UserNode",
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/)
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "source",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ClassesGetAllQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "ClassNodeConnection",
            "kind": "LinkedField",
            "name": "classes",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ClassNode",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v8/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserNode",
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoleNode",
                        "kind": "LinkedField",
                        "name": "roles",
                        "plural": true,
                        "selections": (v15/*: any*/),
                        "storageKey": null
                      },
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ClassNode",
                        "kind": "LinkedField",
                        "name": "classes",
                        "plural": true,
                        "selections": (v15/*: any*/),
                        "storageKey": null
                      },
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ExternalSyncNode",
                    "kind": "LinkedField",
                    "name": "externalSync",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v19/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ClassesGetAllQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "ClassNodeConnection",
            "kind": "LinkedField",
            "name": "classes",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ClassNode",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v8/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserNode",
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoleNode",
                        "kind": "LinkedField",
                        "name": "roles",
                        "plural": true,
                        "selections": (v9/*: any*/),
                        "storageKey": null
                      },
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ClassNode",
                        "kind": "LinkedField",
                        "name": "classes",
                        "plural": true,
                        "selections": (v9/*: any*/),
                        "storageKey": null
                      },
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ExternalSyncNode",
                    "kind": "LinkedField",
                    "name": "externalSync",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v19/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "91a7141a099197051b18938d72195a7a",
    "id": null,
    "metadata": {},
    "name": "ClassesGetAllQuery",
    "operationKind": "query",
    "text": "query ClassesGetAllQuery(\n  $filter: ClassesFilterInput\n  $cursor: String\n  $skip: Boolean = false\n) {\n  classes(classesFilterInput: $filter, first: 100, after: $cursor) @skip(if: $skip) {\n    nodes {\n      id\n      name\n      section\n      site {\n        id\n        name\n      }\n      gradeLevels {\n        name\n        id\n      }\n      isActive\n      users {\n        id\n        firstName\n        lastName\n        publicUserId\n        isActive\n        roles {\n          name\n          id\n        }\n        sites {\n          id\n          name\n        }\n        classes {\n          name\n          id\n        }\n        gradeLevels {\n          name\n          id\n        }\n      }\n      owner {\n        id\n        firstName\n        lastName\n      }\n      externalSync {\n        source\n        id\n      }\n    }\n    pageInfo {\n      endCursor\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1410b9b8316547a78e927c82315f03b5";

export default node;
